export default {
    myinfo : {
        function : "GET",
        url : "/my/info",
    },
}